export const GET_ADDRESS_COORDINATES = gql`
    query GetAddressCoordinate($eircode: String!, $country: String!) {
        addressCoordinate(eircode: $eircode, country: $country) {
            id
            name
            eircode
            latitude
            longitude
            countryCode
        }
    }
`;
